import * as React from 'react';

const MailOpenedSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="mail-opened_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 48 48"
        xmlSpace="preserve"
        {...props}
    >
        <style>{'\n        .mail-opened_svg__st0{fill:#1d0a32}\n    '}</style>
        <path
            className="mail-opened_svg__st0"
            d="M45.6 23.2L40 19.5V11c0-.1 0-.3-.1-.4-.1-.1-.1-.2-.2-.3l-8-8c-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.4-.1H9c-.6 0-1 .4-1 1v16.5l-5.6 3.7c-.2.2-.4.5-.4.8v23c0 .6.4 1 1 1h42c.6 0 1-.4 1-1V24c0-.3-.2-.6-.4-.8zM32 5.4l4.6 4.6H32V5.4zM44 46H4V24.5l4-2.7V27c0 .4.2.7.5.9l15 9c.3.2.7.2 1 0l6-3.6c.5-.3.6-.9.3-1.4s-.9-.6-1.4-.3L24 34.8l-14-8.4V4h20v7c0 .6.4 1 1 1h7v14.4l-3.4 2.1c-.5.3-.6.9-.3 1.4s.9.6 1.4.3l3.9-2.4c.3-.2.5-.5.5-.9v-5.1l4 2.7V46z"
        />
        <path
            className="mail-opened_svg__st0"
            d="M35 23c0-.6-.4-1-1-1H15c-.6 0-1 .4-1 1s.4 1 1 1h19c.6 0 1-.4 1-1zm-20-5h18c.6 0 1-.4 1-1s-.4-1-1-1H15c-.6 0-1 .4-1 1s.4 1 1 1zm0-6h10c.6 0 1-.4 1-1s-.4-1-1-1H15c-.6 0-1 .4-1 1s.4 1 1 1z"
        />
    </svg>
);

MailOpenedSvg.displayName = 'MailOpenedSvg';
export default MailOpenedSvg;
